import { HeadingContext, useSlottedContext } from "react-aria-components";

import { Heading2 } from "./Heading";

export function CalendarHeading() {
  const { children: title } = useSlottedContext(HeadingContext) ?? {};

  return (
    <Heading2 size={1} className="tw:flex-1 tw:text-center tw:text-text-secondary">
      {title}
    </Heading2>
  );
}
